import { Box, SvgIcon } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

export default function FullScreenContainer({ showIcon, isMobile }: any) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const elementRef = useRef<HTMLDivElement | null>(null);

  const toggleFullscreen = () => {
    if (elementRef.current) {
      if (!document.fullscreenElement) {
        elementRef?.current?.parentElement?.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
      setIsFullscreen(!!document.fullscreenElement);
    }
  };

  useEffect(() => {
    function handleFullscreenChange() {
      setIsFullscreen(!!document.fullscreenElement);
      const overflowY = !!document.fullscreenElement ? "scroll" : "";
      if (elementRef.current?.parentElement?.style) {
        elementRef.current.parentElement.style.overflowY = overflowY;
      }
    }
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const toMobile = isMobile
    ? {
        padding: "0px",
        margin: "0px",
      }
    : {};

  return (
    <Box
      ref={elementRef}
      style={{
        zIndex: 1201,
        float: "right",
        right: 0,
        top: 0,
        padding: "10px",
        position: "sticky",
        ...toMobile,
      }}
    >
      {showIcon && (
        <SvgIcon
          sx={{ fontSize: 50, marginRight: 1 }}
          style={toMobile}
          onClick={toggleFullscreen}
          name="full-screen-button"
        >
          {isFullscreen ? (
            <FullscreenExitIcon fontSize="large" />
          ) : (
            <FullscreenIcon fontSize="large" />
          )}
        </SvgIcon>
      )}
    </Box>
  );
}
